module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "About-Us-Leaders.c4cb2853.webp" + "?" + Date.now();